import { render, staticRenderFns } from "./BrowseContextMenu.vue?vue&type=template&id=4eff0dae&scoped=true"
import script from "./BrowseContextMenu.vue?vue&type=script&lang=ts"
export * from "./BrowseContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./BrowseContextMenu.vue?vue&type=style&index=0&id=4eff0dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff0dae",
  null
  
)

export default component.exports